import clsx from 'clsx';
import { FC, memo, useState } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './main-slide.module.scss';
import { IMainSlideProps } from './types';

import copyImg from '../../images/icons/copy.svg';
import { Tooltip, Button, EButtonKinds, Paragraph } from '../ui';

export const MainSlide: FC<IMainSlideProps> = memo(({ data, className = '', ...rest }) => {
  const { slide, slide_mob: slideMob, advertiser, erid, link } = data;
  const [eridText, setEridText] = useState(erid);

  const { t } = useTranslation();

  const handleCopyClick = async () => {
    if (!erid) return;

    try {
      await navigator.clipboard.writeText(erid);

      setEridText(t('main-page.slider.success-copy-text'));

      setTimeout(() => {
        setEridText(erid);
      }, 1500);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={styles.container}>
      {link ? (
        <a className={styles.link} href={link}>
          <img
            className={clsx(styles.img, className)}
            src={window.innerWidth > 600 ? slide : slideMob}
            alt={t('alts.main-slide') ?? ''}
            {...rest}
          />
        </a>
      ) : (
        <img
          className={clsx(styles.img, className)}
          src={window.innerWidth > 600 ? slide : slideMob}
          alt={t('alts.main-slide') ?? ''}
          {...rest}
        />
      )}
      {advertiser && erid && (
        <div className={styles.tooltip_box}>
          <Button
            text={t('main-page.slider.advertiser-btn-text')}
            kind={EButtonKinds.mainSlide}
            className={styles.btn}
          />
          <Tooltip
            text={
              <>
                <Paragraph className={styles.tooltip_text}>{advertiser}</Paragraph>
                <Paragraph className={styles.tooltip_text}>
                  {eridText}
                  {navigator.clipboard && (
                    <button className={styles.copy_btn} onClick={handleCopyClick}>
                      <img
                        className={styles.copy_btn_img}
                        src={copyImg}
                        alt={t('alts.copy-btn') ?? ''}
                      />
                    </button>
                  )}
                </Paragraph>
              </>
            }
            className={styles.tooltip}
            arrowType='right'
            type='main-slide'
          />
        </div>
      )}
    </div>
  );
});
